import Skeleton from "@mui/material/Skeleton";
import { CardBox } from "./ConnectionHomeCard.styles";

const ConnectionHomeCardSkelton = () => (
  <CardBox>
    <Skeleton
      variant="rectangular"
      sx={{ width: "10rem", height: "9rem", borderRadius: "0.5rem" }}
    />
    <Skeleton
      variant="rectangular"
      sx={{ width: "12rem", height: "2rem", borderRadius: "0.5rem" }}
    />
  </CardBox>
);

export default ConnectionHomeCardSkelton;
